import { CSSProperties } from 'react';

import HazardousIcon from 'assets/hazardous.svg';
import { Image } from 'core/elements';

interface IProps {
  isHazardous?: boolean;
  style?: CSSProperties;
}

export const ExternalHazardousIcon = ({ isHazardous, style }: IProps) => {
  if (!isHazardous) {
    return null;
  }

  return <Image src={HazardousIcon} style={{ height: 16, width: 16, ...style }} />;
};
